import './style.scss'
import { useState } from 'react'
import { RiCloseFill } from "react-icons/ri"
import { 
    AbsoluteContainer,
    AppSpan,
    Button,
   CustomContainer, FlexRow, Form, FormGroup, FormGroupWithIcon, SidePopupContainer 
} from "src/style"
import helpers from 'src/utils/helpers'
import { FiChevronDown } from 'react-icons/fi'
import { handleTypeNumberControl } from 'src/utils/utility'

export const Filter: React.FC<any> = ({type, setFilterData, onApplyFilter, top, right, close}) => {
    const [input, setInput] = useState<any>({
        fromDate: null, toDate: null, code: null, 
        category: null, fullName: null, productName: null, 
        serviceCategory: null, username: null, email: null,
        phoneNumber: null, feeId: null, feeName: null,
        serviceType: null, serviceName: null, status: null,
        tagName: null, isActive: null, companyName: null
    })

    let noDateRange = ['']
    let hasInstitutionCode = ['institutions', 'users']
    let hasFullName = ['users', 'sandbox-users', 'audit']
    let hasCategory = ['categories', 'categories-report',]
    let hasCategoryCode = ['categories', 'categories-report', 'service-providers']
    let hasServiceType = ['categories-report', 'service-provider-report']
    let hasServiceName = ['service-provider-report']
    let hasStatus = ['tags', 'api-calls', 'users']


    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => {
        setInput({...input, [e.target.name]: e.target.value})
    }

    async function handleSubmit(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        const payload = {
            ...input, 
            isActive: input.isActive ? (input.isActive == '1') : null
        }
        delete payload.fromDate
        delete payload.toDate

        await setFilterData({
            filter: { ...payload },
            fromDate: input.fromDate,
            toDate: input.toDate
        }) 
        onApplyFilter()
        close()
    }
    
    return (
        <>
            <SidePopupContainer zIndex="7" onClick={close} bgColor='rgba(0,0,0, 0.06)' />
            <AbsoluteContainer 
                zIndex="8" top={top || '40'} right={right || '10'} 
                className="filter-container"
            >
                <CustomContainer
                    width="36" 
                    bgColor="#ffffff" bottomMargin='2'
                    padding="2" radius="1"
                    shadow="0px 4px 10px 0px #0000000D"
                    className='filter-content-container'
                >
                    <FlexRow justifyContent='space-between' gap='2' bottomMargin='2'>
                        <AppSpan color='#101828' textSize='1.8' fontWeight="600">Filter</AppSpan>
                        <Button 
                            titleSize="2" fontWeight="500"
                            width='3.4' shadow='none'
                            height='3.4'
                            radius='0.4'
                            bgColor='#ffffff'
                            hoverBgColor='#FEF3F2'
                            borderColor='none'
                            color='#000000'
                            hoverColor='#B42318'
                            onClick={close}
                        >
                            <RiCloseFill style={{fontSize: '2.3rem'}} />
                        </Button> 
                    </FlexRow>
                    <Form onSubmit={handleSubmit}>
                        { !noDateRange.includes(type) &&
                            <FlexRow 
                                justifyContent='space-between' gap='4' sizeUnit='%'
                                className='filter-input-row'
                            >
                                <FormGroup bottomMargin='0' height='4'>
                                    <label>Start Date</label>
                                    <input 
                                        name='fromDate'
                                        type='date'
                                        max={helpers.getInputValidDate()}
                                        style={{color: input.fromDate ? '#000000' : '#667085'}}
                                        value={input.fromDate}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    />
                                </FormGroup>
                                <FormGroup bottomMargin='0'  height='4'>
                                    <label>End Date</label>
                                    <input 
                                        name='toDate'
                                        type='date'
                                        max={helpers.getInputValidDate()}
                                        style={{color: input.toDate ? '#000000' : '#667085'}}
                                        value={input.toDate}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    />
                                </FormGroup>
                            </FlexRow>
                        }
                        { hasCategory.includes(type) &&
                            <FormGroup height='4'>
                                <label>Category Name</label>
                                <input 
                                    placeholder='Enter category name'
                                    name='category'
                                    value={input.category}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                        }
                        { hasServiceName.includes(type) &&
                            <FormGroup height='4'>
                                <label>Service Name</label>
                                <input 
                                    placeholder='Enter service name'
                                    name='serviceName'
                                    value={input.serviceName}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                        }
                        { hasServiceType.includes(type) &&
                            <FormGroup height='4'>
                                <label>Sevice Type</label>
                                <input 
                                    placeholder='Enter service type'
                                    name='serviceType'
                                    value={input.serviceType}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                        }
                        { hasCategoryCode.includes(type) &&
                            <FormGroup height='4'>
                                <label>Code</label>
                                <input 
                                    placeholder='Enter code'
                                    name='code'
                                    value={input.code}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                        }
                        { hasFullName.includes(type) &&
                            <FormGroup height='4'>
                                <label>Full Name</label>
                                <input 
                                    placeholder='Enter fullname'
                                    name='fullName'
                                    value={input.fullName}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                        }
                        { type === 'sandbox-users' &&
                            <>
                                <FormGroup height='4'>
                                    <label>product Name</label>
                                    <input 
                                        placeholder='Enter product name'
                                        name='productName'
                                        value={input.productName}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    />
                                </FormGroup>
                                <FormGroup height='4'>
                                    <label>Service Category</label>
                                    <input 
                                        placeholder='Enter service category'
                                        name='serviceCategory'
                                        value={input.serviceCategory}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    />
                                </FormGroup>
                            </>
                        }
                        { type === 'users' &&
                            <>
                                <FormGroup height='4'>
                                    <label>Username</label>
                                    <input 
                                        placeholder='Enter username'
                                        name='username'
                                        value={input.username}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    />
                                </FormGroup>
                                <FormGroup height='4'>
                                    <label>Email</label>
                                    <input 
                                        placeholder='Enter email'
                                        name='email'
                                        type='email'
                                        value={input.email}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    />
                                </FormGroup>
                                <FormGroup height='4'>
                                    <label>Phone number</label>
                                    <input 
                                        placeholder='Enter phone number'
                                        name='phoneNumber'
                                        value={input.phoneNumber}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    />
                                </FormGroup>
                            </>
                        }
                        {/* { type === 'fees' &&
                            <>
                                <FormGroup height='4'>
                                    <label>Fee ID</label>
                                    <input 
                                        placeholder='Enter fee ID'
                                        name='feeId'
                                        value={input.feeId}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    />
                                </FormGroup>
                                <FormGroup height='4'>
                                    <label>Fee name</label>
                                    <input 
                                        placeholder='Enter fee name'
                                        name='feeName'
                                        value={input.feeName}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    />
                                </FormGroup>
                            </>
                        } */}
                        { type === 'tags' &&
                            <FormGroup height='4'>
                                <label>Tag name</label>
                                <input 
                                    placeholder='Enter tag name'
                                    name='tagName'
                                    value={input.tagName}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                        }

                        { type === 'service-providers' &&
                            <FormGroup height='4'>
                                <label>Company name</label>
                                <input 
                                    placeholder='Enter name'
                                    name='companyName'
                                    value={input.companyName}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                        }

                        { type === 'fees' &&
                            <FormGroupWithIcon >
                                <label>IsActive</label>
                                <div className="input-with-icon" style={{height: '4rem'}}>
                                    <select 
                                        name='isActive'
                                        value={input.isActive}
                                        style={{color: input.isActive ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    >
                                        <option value="">Select</option>
                                        <option value="1">True</option>
                                        <option value="0">False</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                        }
                        
                        { hasStatus.includes(type) &&
                            <FormGroupWithIcon >
                                <label>Status</label>
                                <div className="input-with-icon" style={{height: '4rem'}}>
                                    <select 
                                        name='status'
                                        value={input.status}
                                        style={{color: input.status ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    >
                                        <option value="">Select status</option>
                                        <option value="Active">Active</option>
                                        <option value="Inactive">Inactive</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                        }
                        <FlexRow justifyContent='flex-end' topMargin='2'>
                            <Button 
                                width='11.2' height='4'
                                borderColor='#0D968F' hoverBgColor='#fff' 
                                hoverColor='#0D968F' titleSize='1.4'
                            >
                                Apply filter
                            </Button>
                        </FlexRow>
                    </Form>
                </CustomContainer>
            </AbsoluteContainer>
        </>
    )
}